export const translations = {
  nav: {
    home: { pt: 'Início', en: 'Home' },
    services: { pt: 'Serviços', en: 'Services' },
    about: { pt: 'Sobre', en: 'About' },
    appointments: { pt: 'Marcações', en: 'Appointments' },
    contact: { pt: 'Contacto', en: 'Contact' },
    privacy: { pt: 'Privacidade', en: 'Privacy' },
  },
  hero: {
    title: {
      pt: 'Recupere o seu movimento',
      en: 'Recover your movement'
    },
    subtitle: {
      pt: 'Fisioterapia personalizada na Ericeira. Especialista em reabilitação física e lesões de surf.',
      en: 'Personalized physiotherapy in Ericeira. Specialist in physical rehabilitation and surf injuries.'
    },
    cta: {
      pt: 'Marcar avaliação',
      en: 'Book an appointment'
    },
    ctaSecondary: {
      pt: 'Conhecer serviços',
      en: 'View services'
    }
  },
  features: {
    title: { pt: 'Porquê escolher-nos', en: 'Why choose us' },
    individual: {
      title: { pt: 'Acompanhamento individual', en: 'Individual care' },
      desc: { pt: 'Atenção dedicada em cada sessão, focada nas suas necessidades específicas.', en: 'Dedicated attention in each session, focused on your specific needs.' }
    },
    recovery: {
      title: { pt: 'Recuperação funcional', en: 'Functional recovery' },
      desc: { pt: 'Foco em restaurar a sua mobilidade e qualidade de vida.', en: 'Focus on restoring your mobility and quality of life.' }
    },
    surf: {
      title: { pt: 'Especialista em surf', en: 'Surf specialist' },
      desc: { pt: 'Experiência comprovada em lesões relacionadas com o surf e desportos de impacto.', en: 'Proven experience in surf-related injuries and impact sports.' }
    }
  },
  services: {
    title: { pt: 'Serviços', en: 'Services' },
    subtitle: { pt: 'Tratamentos especializados para a sua recuperação', en: 'Specialized treatments for your recovery' },
    musculoskeletal: {
      title: { pt: 'Fisioterapia músculo-esquelética', en: 'Musculoskeletal physiotherapy' },
      desc: { pt: 'Tratamento de lesões musculares, articulares e ósseas através de técnicas manuais e exercícios terapêuticos.', en: 'Treatment of muscle, joint and bone injuries through manual techniques and therapeutic exercises.' }
    },
    rehabilitation: {
      title: { pt: 'Reabilitação pós-lesão', en: 'Post-injury rehabilitation' },
      desc: { pt: 'Programa personalizado de recuperação após cirurgias, fraturas ou lesões desportivas.', en: 'Personalized recovery program after surgeries, fractures or sports injuries.' }
    },
    backPain: {
      title: { pt: 'Tratamento de dor lombar e cervical', en: 'Back and neck pain treatment' },
      desc: { pt: 'Alívio da dor e correção postural através de terapia manual e exercícios específicos.', en: 'Pain relief and postural correction through manual therapy and specific exercises.' }
    },
    surfInjury: {
      title: { pt: 'Recuperação de lesões de surf', en: 'Surf injury recovery' },
      desc: { pt: 'Tratamento especializado em lesões comuns no surf: ombro, joelho, lombar e cervical.', en: 'Specialized treatment for common surf injuries: shoulder, knee, lower back and neck.' }
    },
    personalized: {
      title: { pt: 'Acompanhamento personalizado', en: 'Personalized care' },
      desc: { pt: 'Plano de tratamento adaptado às suas necessidades, objetivos e estilo de vida.', en: 'Treatment plan adapted to your needs, goals and lifestyle.' }
    },
    prevention: {
      title: { pt: 'Prevenção de lesões', en: 'Injury prevention' },
      desc: { pt: 'Avaliação funcional e programa de exercícios para prevenir lesões futuras.', en: 'Functional assessment and exercise program to prevent future injuries.' }
    }
  },
  about: {
    title: { pt: 'Sobre mim', en: 'About me' },
    subtitle: { pt: 'Conheça o seu fisioterapeuta', en: 'Meet your physiotherapist' },
    intro: {
      pt: 'Sou o Miguel Andrade, fisioterapeuta licenciado com experiência em reabilitação física e tratamento de lesões desportivas. A minha abordagem combina técnicas baseadas em evidência científica com um acompanhamento próximo e personalizado.',
      en: "I'm Miguel Andrade, a licensed physiotherapist with experience in physical rehabilitation and sports injury treatment. My approach combines evidence-based techniques with close, personalized follow-up."
    },
    philosophy: {
      title: { pt: 'A minha filosofia', en: 'My philosophy' },
      text: {
        pt: 'Acredito que cada pessoa é única e merece um tratamento adaptado às suas necessidades específicas. O meu objetivo não é apenas aliviar a dor, mas ajudá-lo a recuperar a sua função e qualidade de vida.',
        en: 'I believe that each person is unique and deserves treatment adapted to their specific needs. My goal is not only to relieve pain, but to help you recover your function and quality of life.'
      }
    },
    experience: {
      title: { pt: 'Experiência', en: 'Experience' },
      items: {
        pt: [
          'Licenciatura em Fisioterapia',
          'Experiência em clínica privada e desportiva',
          'Especialização em lesões de surf e desportos aquáticos',
          'Formação contínua em terapia manual e exercício terapêutico'
        ],
        en: [
          'Degree in Physiotherapy',
          'Experience in private and sports clinics',
          'Specialization in surf and water sports injuries',
          'Ongoing training in manual therapy and therapeutic exercise'
        ]
      }
    }
  },
  appointments: {
    title: { pt: 'Marcações', en: 'Appointments' },
    subtitle: { pt: 'Agende a sua consulta', en: 'Schedule your appointment' },
    intro: {
      pt: 'Reserve a sua avaliação inicial através do calendário abaixo. A primeira consulta inclui uma avaliação completa e definição do plano de tratamento.',
      en: 'Book your initial assessment through the calendar below. The first consultation includes a complete evaluation and treatment plan definition.'
    },
    alternative: {
      pt: 'Prefere contactar-nos diretamente?',
      en: 'Prefer to contact us directly?'
    },
    whatsapp: {
      pt: 'Enviar mensagem no WhatsApp',
      en: 'Send a WhatsApp message'
    }
  },
  contact: {
    title: { pt: 'Contacto', en: 'Contact' },
    subtitle: { pt: 'Entre em contacto', en: 'Get in touch' },
    address: { pt: 'Morada', en: 'Address' },
    phone: { pt: 'Telefone', en: 'Phone' },
    hours: { pt: 'Horário', en: 'Hours' },
    hoursDetail: {
      pt: ['Segunda a Sexta: 9:00 – 19:30', 'Sábado: 9:00 – 13:00', 'Domingo: Encerrado'],
      en: ['Monday to Friday: 9:00 AM – 7:30 PM', 'Saturday: 9:00 AM – 1:00 PM', 'Sunday: Closed']
    },
    form: {
      title: { pt: 'Envie-nos uma mensagem', en: 'Send us a message' },
      name: { pt: 'Nome', en: 'Name' },
      email: { pt: 'Email', en: 'Email' },
      phone: { pt: 'Telefone', en: 'Phone' },
      message: { pt: 'Mensagem', en: 'Message' },
      submit: { pt: 'Enviar mensagem', en: 'Send message' },
      success: { pt: 'Mensagem enviada com sucesso!', en: 'Message sent successfully!' },
      error: { pt: 'Erro ao enviar mensagem. Tente novamente.', en: 'Error sending message. Please try again.' }
    }
  },
  privacy: {
    title: { pt: 'Política de Privacidade', en: 'Privacy Policy' },
    lastUpdated: { pt: 'Última atualização', en: 'Last updated' },
    sections: {
      intro: {
        title: { pt: 'Introdução', en: 'Introduction' },
        text: {
          pt: 'A sua privacidade é importante para nós. Esta política de privacidade explica como recolhemos, utilizamos e protegemos os seus dados pessoais quando utiliza o nosso website e serviços.',
          en: 'Your privacy is important to us. This privacy policy explains how we collect, use and protect your personal data when you use our website and services.'
        }
      },
      dataCollection: {
        title: { pt: 'Dados que recolhemos', en: 'Data we collect' },
        text: {
          pt: 'Recolhemos apenas os dados necessários para prestar os nossos serviços: nome, email, telefone e informações de saúde relevantes para o tratamento. Estes dados são recolhidos através do formulário de contacto e durante as consultas.',
          en: 'We only collect the data necessary to provide our services: name, email, phone and health information relevant to treatment. This data is collected through the contact form and during consultations.'
        }
      },
      dataUse: {
        title: { pt: 'Como utilizamos os seus dados', en: 'How we use your data' },
        text: {
          pt: 'Utilizamos os seus dados para: agendar e gerir consultas, comunicar sobre o seu tratamento, e cumprir obrigações legais. Nunca partilhamos os seus dados com terceiros para fins comerciais.',
          en: 'We use your data to: schedule and manage appointments, communicate about your treatment, and comply with legal obligations. We never share your data with third parties for commercial purposes.'
        }
      },
      rights: {
        title: { pt: 'Os seus direitos', en: 'Your rights' },
        text: {
          pt: 'Ao abrigo do RGPD, tem direito a: aceder aos seus dados, retificar informações incorretas, solicitar a eliminação dos seus dados, e retirar o seu consentimento a qualquer momento.',
          en: 'Under GDPR, you have the right to: access your data, rectify incorrect information, request deletion of your data, and withdraw your consent at any time.'
        }
      },
      contact: {
        title: { pt: 'Contacto', en: 'Contact' },
        text: {
          pt: 'Para questões sobre privacidade ou para exercer os seus direitos, contacte-nos através do email info@diogoh.pt ou telefone +351 911 739 498.',
          en: 'For privacy questions or to exercise your rights, contact us at info@diogoh.pt or phone +351 911 739 498.'
        }
      }
    }
  },
  footer: {
    rights: { pt: 'Todos os direitos reservados', en: 'All rights reserved' },
    privacy: { pt: 'Política de Privacidade', en: 'Privacy Policy' }
  },
  whatsapp: {
    tooltip: { pt: 'Enviar mensagem no WhatsApp', en: 'Send WhatsApp message' }
  }
};
